<template>
    <div class="__l">
        <h1 class="title">Knowledgebase Categories</h1>
        <div class="actions right text-right">
            <button class="btn-primary" type="button" @click="createCategory">Create Category</button>
        </div>
        <input type="text" v-model="search" class="form-field py-4 px-6" ref="searchbar"
               placeholder="Search for Category" @keyup.enter="handleSearch">

        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="10%">ID</div>
                <div class="results-head" data-width="40%">Title</div>
                <div class="results-head" data-width="30%">Slug</div>
                <div class="results-head" data-width="20%">Container</div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index"
                     @click="handleSelectedCategory(result)">
                    <div class="results-cell" data-width="10%">{{ result.kcat_id }}</div>
                    <div class="results-cell truncate" data-width="40%">{{ result.kcat_title }}</div>
                    <div class="results-cell truncate" data-width="30%">{{ result.kcat_slug }}</div>
                    <div class="results-cell truncate" data-width="20%">
                        {{ result.container ? result.container.name : '(Default)' }}
                    </div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="25" @paginate="loadData"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import KnowledgebaseCategoriesView from './View'
import Pagination from 'v-pagination-3'

export default {
    name: 'KnowledgebaseCategories',
    data() {
        return {
            search: null,
            results: {},
            page: 1,
        }
    },
    components: {
        Pagination,
        KnowledgebaseCategoriesView,
    },
    mounted() {
        window.setTimeout(function () {
            this.$refs.searchbar.focus()
        }.bind(this), 100)

        this.setMetaTitle('List Knowledgebase Categories | JournoLink Control')
    },
    methods: {
        handleSearch() {
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('knowledgebase.categories.list'), {
                params: {
                    term: this.search,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle the selection of an Category
         *
         * @param  {Object}
         * @return {void}
         */
        handleSelectedCategory(category) {
            this.$router.push({name: 'knowledgebase.categories.show', params: {categoryId: category.kcat_id}})
        },
        /**
         * Create a new Category
         *
         * @return {void}
         */
        createCategory() {
            this.$router.push({name: 'knowledgebase.categories.create'})
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to && to.name === 'knowledgebase.categories.list') {
            this.setMetaTitle('List Knowledgebase Categories | JournoLink Control')
            this.loadData()
        }

        if (to && to.params.newCategory) {
            window.setTimeout(() => {
                this.handleSelectedCategory(to.params.newCategory)
            }, 500)

            next()
        }

        next()
    },
}
</script>

<style lang="less">

</style>
